<div class="btn-group">
  <button class="btn btn-bold py-1" [ngClass]="buttonClass" (click)="previous()" [disabled]="selectedOption === 'Today'">
    <i class="bi bi-chevron-left p-0"></i>
  </button>
  <button class="btn py-1" [ngClass]="buttonClass" #range><i class="flaticon2-calendar-9"></i>{{displayLabel}}</button>
  <button class="btn btn-bold py-1" [ngClass]="buttonClass" (click)="next()"
    [disabled]="selectedOption === 'All' || selectedOption === 'Custom Range'">
    <i class="bi bi-chevron-right p-0"></i>
  </button>
</div>